<ng-template cellTemplate let-dataItem="dataItem">
    <div class="view">
        <div class="view-action">
            <fui-link-button *ngIf="!isSelectMode" (click)="fireEditEvent(dataItem)" [title]="getValue(dataItem)"></fui-link-button>
            <span *ngIf="isSelectMode">{{getValue(dataItem)}}</span>
        </div>
        <div class="view-tag">
            <fui-tags class="utility color-dusty-gray">
                <fui-tag *ngIf="searchModel.isDiscontinued(dataItem)" [title]="discontinuedLabel">
                    <fui-icon [height]="14" [icon]="'ban'" [width]="14"></fui-icon>
                </fui-tag>
            </fui-tags>
        </div>
    </div>
</ng-template>
